import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/diagnostic-concept-template";


export const pagingDiagnosticConceptTemplate = searchDiagnosticConceptTemplate => axios.post(API_PATH + "/search-by-page", searchDiagnosticConceptTemplate);

export const getDiagnosticConceptTemplateById = diagnosticConceptTemplateId => axios.get(API_PATH + "/get-by-id/" + diagnosticConceptTemplateId);
export const getDiagConceptServiceById = DiagnosticConceptTemplateId => axios.get(API_PATH + "/get-diag-concept-service-by-id/" + DiagnosticConceptTemplateId);

export const saveOrUpdateDiagnosticConceptTemplate = diagnosticConceptTemplate => axios.post(API_PATH + '/save-or-update', diagnosticConceptTemplate);
export const saveOrUpdateDiagConceptService = diagnosticConceptTemplate => axios.post(API_PATH + '/save-or-update-diag-concept-service', diagnosticConceptTemplate);

export const deleteDiagnosticConceptTemplate = diagnosticConceptTemplateId => axios.delete(API_PATH + "/mark-delete/" + diagnosticConceptTemplateId)

export const searchServiceByPage = searchDiagnosticConceptTemplate => axios.post(API_PATH + "/search-service-by-page", searchDiagnosticConceptTemplate);

export const deleteDepartmentById = departmentId => axios.delete(API_PATH + "/mark-delete/" + departmentId);
export const markDeleteDiagnosticConceptService = departmentId => axios.delete(API_PATH + "/mark-delete-diag-concept-service/" + departmentId);